import { NgModule } from '@angular/core';
import { PhoneInputComponent } from './phone-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { SelectSearchModule } from '../select-search/select-search.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxMaskModule } from 'ngx-mask';
import { CountryCodeModule } from '../country-code/country-code.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [PhoneInputComponent],
  imports: [
    IntrackFeatureModule,
    SelectSearchModule,
    TranslateModule,
    NgxMatSelectSearchModule,
    NgxMaskModule,
    CountryCodeModule,
    SvgIconModule,
  ],
  exports: [PhoneInputComponent],
})
export class PhoneInputModule {}
